import { render } from "./Proof.vue?vue&type=template&id=e854d7b0"
import script from "./Proof.vue?vue&type=script&lang=ts"
export * from "./Proof.vue?vue&type=script&lang=ts"
script.render = render

export default script